import { IPromise } from 'angular';

import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { Module } from '../../ts/Module';
import { DeleteDataSourceVersionsRequest } from '../../ts/ServerApi/requests/DeleteDataSourceVersionsRequest';
import {
  GetDatasourceVersionsRequest,
  IGetDatasourceVersionsResult,
} from '../serverApi/requests/getDatasourceVersionsRequest';
import { IDatasourceRevision } from '../serverApi/types/IDatasourceRevision';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToast, WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { FetcherFactory } from '../../ts/services/FetcherFactory';
import { Resource } from '../../ts/resources/Resource';

export class DatasourceRevisions extends Resource<IDatasourceRevision>  {

  public static $inject = ['FetcherFactory'];


  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetDatasourceVersionsRequest,
      (result: IGetDatasourceVersionsResult) => result.versions));
  }

  public del = (id: string): IPromise<IResult> => {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteDataSourceVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

}

Module.instance().service('DatasourceRevisions', DatasourceRevisions);
